export const standart = [
  {
    keys: [
      { icon: 'arrow-left', special: 'left', span: 1 },
      { icon: 'arrow-right', special: 'right', span: 1 },
      { icon: 'input', span: 11, focusable: false },
      { icon: 'delete', special: 'delete', span: 2 },
    ],
  },
  {
    keys: [
      { character: '1', alt: '1', span: 1 },
      { character: '2', alt: '2', span: 1 },
      { character: '3', alt: '3', span: 1 },
      { character: '4', alt: '4', span: 1 },
      { character: '5', alt: '5', span: 1 },
      { character: '6', alt: '6', span: 1 },
      { character: '7', alt: '7', span: 1 },
      { character: '8', alt: '8', span: 1 },
      { character: '9', alt: '9', span: 1 },
      { character: '0', alt: '0', span: 1 },
      { character: '_', alt: '_', span: 1 },
      { character: 'SHIFT', alt: 'SHIFT', span: 2, special: 'shift' },
    ],
  },
  {
    keys: [
      { character: 'q', shift: 'Q', alt: '!', span: 1 },
      { character: 'w', shift: 'W', alt: '@', span: 1 },
      { character: 'e', shift: 'E', alt: '#', span: 1 },
      { character: 'r', shift: 'R', alt: '$', span: 1 },
      { character: 't', shift: 'T', alt: '%', span: 1, focused: true },
      { character: 'y', shift: 'Y', alt: '^', span: 1 },
      { character: 'u', shift: 'U', alt: '&', span: 1 },
      { character: 'i', shift: 'I', alt: '*', span: 1 },
      { character: 'o', shift: 'O', alt: '(', span: 1 },
      { character: 'p', shift: 'P', alt: ')', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'a', shift: 'A', alt: '?', span: 1 },
      { character: 's', shift: 'S', alt: '<', span: 1 },
      { character: 'd', shift: 'D', alt: '>', span: 1 },
      { character: 'f', shift: 'F', alt: '{', span: 1 },
      { character: 'g', shift: 'G', alt: '}', span: 1 },
      { character: 'h', shift: 'H', alt: '\\', span: 1 },
      { character: 'j', shift: 'J', alt: '|', span: 1 },
      { character: 'k', shift: 'K', alt: '/', span: 1 },
      { character: 'l', shift: 'L', alt: '`', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'z', shift: 'Z', alt: '.', span: 1 },
      { character: 'x', shift: 'X', alt: ':', span: 1 },
      { character: 'c', shift: 'C', alt: ';', span: 1 },
      { character: 'v', shift: 'V', alt: '№', span: 1 },
      { character: 'b', shift: 'B', alt: '£', span: 1 },
      { character: 'n', shift: 'N', alt: '~', span: 1 },
      { character: 'm', shift: 'M', alt: '"', span: 1 },
    ],
  },
  {
    keys: [
      { character: '=/+', alt: 'abc', span: 1, special: 'alt' },
      { character: 'SPACE', alt: 'SPACE', special: 'space', span: 4 },
      { character: '.', alt: ',', span: 1 },
      { character: '-', alt: '-', span: 1 },
    ],
  },
];

export const noEmbeddedInput = [
  {
    keys: [
      { icon: 'arrow-left', special: 'left', span: 1 },
      { icon: 'arrow-right', special: 'right', span: 1 },
      { character: '1', alt: '1', span: 1 },
      { character: '2', alt: '2', span: 1 },
      { character: '3', alt: '3', span: 1 },
      { character: '4', alt: '4', span: 1 },
      { character: '5', alt: '5', span: 1 },
      { character: '6', alt: '6', span: 1 },
      { character: '7', alt: '7', span: 1 },
      { character: '8', alt: '8', span: 1 },
      { character: '9', alt: '9', span: 1 },
      { character: '0', alt: '0', span: 1 },
      { character: '_', alt: '_', span: 1 },
      { icon: 'delete', special: 'delete', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'SHIFT', alt: 'SHIFT', span: 2, special: 'shift' },
      { character: 'q', shift: 'Q', alt: '!', span: 1 },
      { character: 'w', shift: 'W', alt: '@', span: 1 },
      { character: 'e', shift: 'E', alt: '#', span: 1 },
      { character: 'r', shift: 'R', alt: '$', span: 1 },
      { character: 't', shift: 'T', alt: '%', span: 1, focused: true },
      { character: 'y', shift: 'Y', alt: '^', span: 1 },
      { character: 'u', shift: 'U', alt: '&', span: 1 },
      { character: 'i', shift: 'I', alt: '*', span: 1 },
      { character: 'o', shift: 'O', alt: '(', span: 1 },
      { character: 'p', shift: 'P', alt: ')', span: 1 },
      { character: 'SHIFT', alt: 'SHIFT', span: 2, special: 'shift' },
    ],
  },
  {
    keys: [
      { character: 'a', shift: 'A', alt: '?', span: 1 },
      { character: 's', shift: 'S', alt: '<', span: 1 },
      { character: 'd', shift: 'D', alt: '>', span: 1 },
      { character: 'f', shift: 'F', alt: '{', span: 1 },
      { character: 'g', shift: 'G', alt: '}', span: 1 },
      { character: 'h', shift: 'H', alt: '\\', span: 1 },
      { character: 'j', shift: 'J', alt: '|', span: 1 },
      { character: 'k', shift: 'K', alt: '/', span: 1 },
      { character: 'l', shift: 'L', alt: '`', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'z', shift: 'Z', alt: '.', span: 1 },
      { character: 'x', shift: 'X', alt: ':', span: 1 },
      { character: 'c', shift: 'C', alt: ';', span: 1 },
      { character: 'v', shift: 'V', alt: '№', span: 1 },
      { character: 'b', shift: 'B', alt: '£', span: 1 },
      { character: 'n', shift: 'N', alt: '~', span: 1 },
      { character: 'm', shift: 'M', alt: '"', span: 1 },
    ],
  },
  {
    keys: [
      { character: '=/+', alt: 'abc', span: 1, special: 'alt' },
      { character: 'SPACE', alt: 'SPACE', special: 'space', span: 4 },
      { character: '.', alt: ',', span: 1 },
      { character: '-', alt: '-', span: 1 },
    ],
  },
];

export const email = [
  {
    keys: [
      { icon: 'arrow-left', special: 'left', span: 1 },
      { icon: 'arrow-right', special: 'right', span: 1 },
      { character: '1', alt: '1', span: 1 },
      { character: '2', alt: '2', span: 1 },
      { character: '3', alt: '3', span: 1 },
      { character: '4', alt: '4', span: 1 },
      { character: '5', alt: '5', span: 1 },
      { character: '6', alt: '6', span: 1 },
      { character: '7', alt: '7', span: 1 },
      { character: '8', alt: '8', span: 1 },
      { character: '9', alt: '9', span: 1 },
      { character: '0', alt: '0', span: 1 },
      { character: '_', alt: '_', span: 1 },
      { icon: 'delete', special: 'delete', span: 2 },
    ],
  },
  {
    keys: [
      { character: 'SHIFT', alt: 'SHIFT', span: 2, special: 'shift' },
      { character: 'q', shift: 'Q', alt: '!', span: 1 },
      { character: 'w', shift: 'W', alt: '@', span: 1 },
      { character: 'e', shift: 'E', alt: '#', span: 1 },
      { character: 'r', shift: 'R', alt: '$', span: 1 },
      { character: 't', shift: 'T', alt: '%', span: 1, focused: true },
      { character: 'y', shift: 'Y', alt: '^', span: 1 },
      { character: 'u', shift: 'U', alt: '&', span: 1 },
      { character: 'i', shift: 'I', alt: '*', span: 1 },
      { character: 'o', shift: 'O', alt: '(', span: 1 },
      { character: 'p', shift: 'P', alt: ')', span: 1 },
      { character: 'SHIFT', alt: 'SHIFT', span: 2, special: 'shift' },
    ],
  },
  {
    keys: [
      { character: 'a', shift: 'A', alt: '?', span: 1 },
      { character: 's', shift: 'S', alt: '<', span: 1 },
      { character: 'd', shift: 'D', alt: '>', span: 1 },
      { character: 'f', shift: 'F', alt: '{', span: 1 },
      { character: 'g', shift: 'G', alt: '}', span: 1 },
      { character: 'h', shift: 'H', alt: '\\', span: 1 },
      { character: 'j', shift: 'J', alt: '|', span: 1 },
      { character: 'k', shift: 'K', alt: '/', span: 1 },
      { character: 'l', shift: 'L', alt: '`', span: 1 },
    ],
  },
  {
    keys: [
      { character: 'z', shift: 'Z', alt: '.', span: 1 },
      { character: 'x', shift: 'X', alt: ':', span: 1 },
      { character: 'c', shift: 'C', alt: ';', span: 1 },
      { character: 'v', shift: 'V', alt: '№', span: 1 },
      { character: 'b', shift: 'B', alt: '£', span: 1 },
      { character: 'n', shift: 'N', alt: '~', span: 1 },
      { character: 'm', shift: 'M', alt: '"', span: 1 },
    ],
  },
  {
    keys: [
      { character: '=/+', alt: 'abc', span: 1, special: 'alt' },
      { character: '@', alt: '@', span: 1 },
      { character: 'SPACE', alt: 'SPACE', special: 'space', span: 3 },
      { character: '.', alt: ',', span: 1 },
      { character: '-', alt: '-', span: 1 },
      { character: 'gmail.com', alt: 'gmail.com', smallFont: true, span: 2 },
    ],
  },
];

export default standart;
